import { SHARED_APPLICATIONS, SHARED_MODALS } from '../core';
import TeamApp from './apps/_team/app';
import ConsoleApp from './apps/_console/app';
import { SelectTagsModal, SelectGeoLocationTagsModal } from './modals';
import { ProjectViewModal } from './modals/projectViewModal';
import { CompetitionBravoModal } from './modals/competitionBravoModal';
import { CompetitionBravoErrorModal } from './modals/competitionBravoErrorModal';
import { CompetitionLegalsModal } from './modals/competitionLegalsModal/competitionLegalsModal';
import { SendProjectModal } from './modals/sendProjects/SendProjectModal';
import { FeedbackForm } from './components/feedbackForm';
import { ReportForm } from './components/reportForm';
import { NotSavedDataModal } from './modals/notSavedData/notSavedData';
import { SelectChapters } from './modals/selectChapters/SelectChapters';
import { LegalsModal } from "./modals/legalsModal";
import { SelectShortList } from './modals/selectShortList/SelectShortList';
import {SendProjectForEmploy} from "./modals/sendProjects/SendProjectForEmploy";
import {ShareModal} from "./modals/ShareModal/ShareModal";
import TermsOfUseModal from './modals/TermsOfUseModal';
import NotificationList from "./components/NotificationsController/NotificationList";
import {     
    ArtzLegalsModal,
    ErrorModal,
    SuccessModal,
    LoadingModal } from './modals/artzLegalsModal';
import GroupModal from './modals/groups';
import {SendBrndItemModal} from "./modals/sendProjects/SendBrndItemModal";
import {SendImagesModal} from "./modals/sendProjects/SendImagesModal";
import {ScheduleModal} from "./modals/scheduleModal/scheduleModal";
import {CheckHomeworkModal} from './modals/checkHomeworkModal/checkHomeworkModal';
import {PreviewerModal} from "./modals/previewerModal/previewerModal";
import {SendProjectLongreadModal} from "./modals/sendProjects/SendProjectLongreadModal";
import PaymentError from "./features/QueuePaymenrt/payment/PaymentError";
import PaymentSuccess from "./features/QueuePaymenrt/payment/PaymentSuccess";
import PaymentManager from "./features/QueuePaymenrt/payment/PaymentManager";
import { SendProjectToCompetition } from './modals/sendProjects/SendProjectToCompetition';
import {BookPaymentSuccess} from "./features/QueuePaymenrt/components/BookPaymentSuccess/BookPaymentSuccess";
import TopUpBalance from './features/QueuePaymenrt/payment/TopUpBalance';
import { AgeRestrictionModal } from "./modals/AgeRestrictionModal/AgeRestrictionModal";
import { CustomLegalsModal } from './modals/customLegalsModal/customLegalsModal';
import { ProjectPublishModal } from './modals/projectPublishModal/ProjectPublishModal';
import { PaymentErrorModal } from './modals/PaymentErrorModal';
import { SortingModal } from './modals/SortingModal/SortingModal';
import {TeamSubscribe} from "./modals/TeamSubscribe/TeamSubscribe";
import { CustomInfoModal } from './modals/CustomInfoModal/CustomInfoModal';
import {SelectContextModalNew} from "./modals/selectContextModalNew";
import { CreateTagComponent } from './modals/selectTagsModal/components/CreateTagComponent/CreateTagComponent';
import {CodeViewerModal} from "./modals/CodeViewerModal/CodeViewerModal";
import { LockDataModal } from './modals/lockDataModal/LockDataModal';
import { FoldersProjectsEdit } from './modals/FolderModal';
import ProductsSelectModal from './modals/CardSelectModal/ProductsSelectModal';
import ReproductionSelectModal from './modals/CardSelectModal/ReproductionSelectModal';
import { ConfirmDeleteCoverModal } from './modals/confirmCoverDeleteModal';
import { SubscribeUserModal } from './modals/subscribeUser/SubscribeUserModal';
import { FormDropdownEdit } from './modals/formDropdownEdit/FormDropdownEdit';
import {ApplicationFormTemplate} from "./modals/ApplicationFormTemplate/applicationFormTemplate";
import { TagDescriptionModal } from './modals/TagDescriptionModal/TagDescriptionModal';
import { RepostModal } from './modals/repostModal/RepostModal';
import { TemplateModal } from './modals/TemplateModal/TemplateModal';
import { ConfirmCourseCompletionModal } from './modals/ConfirmCourseCompletion';
import CollectionsSelectModal from './modals/CardSelectModal/CollectionsSelectModal';
import CalendarsSelectModal from './modals/CardSelectModal/CalendarsSelectModal';
import { FormulaEditor } from './pages/projectEdit/components/PresentatitonBlock/FormulaEditor';
import { AccessModal } from './modals/AccessModal/AccessModal';
import { ConfirmationModal } from './modals/ConfirmationModal/ConfirmationModal';

import PaymentUnavailableModal from './modals/PaymentUnavailableModal/PaymentUnavailableModal';
import SendConfirmation from './modals/SendConfirmation/SendConfirmation';
import CompetitionProjectSent from './modals/CompetitionProjectSent/CompetitionProjectSent';

export const setupApp = (): void => {
    SHARED_APPLICATIONS['team'] = TeamApp;
    SHARED_APPLICATIONS['console'] = ConsoleApp;

    SHARED_MODALS['confirmDeleteCoverModal'] = {
        closable: true,
        component: ConfirmDeleteCoverModal,
        closeLeft: true,
        customFillBackgroundColor: 'rgba(0,0,0,0.20)'
        
    };

    SHARED_MODALS['context-new'] = {
        closable: true,
        component: SelectContextModalNew,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['notifications'] = {
        closable: false,
        component: NotificationList,
        solidBackground: true,
        closeLeft: false,
        headerVisibleMobile: true,
        containerId: "notification-dropdown",
    };
    SHARED_MODALS['subscribe-user'] = {
        closable: false,
        component: SubscribeUserModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['template-modal'] = {
        closable: false,
        component: TemplateModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['repost-into-channel'] = {
        closable: false,
        component: RepostModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }

    SHARED_MODALS['form-dropdown-edit'] = {
        closable: false,
        component: FormDropdownEdit,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['template-modal'] = {
        closable: false,
        component: TemplateModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['project'] = {
        closable: true,
        component: ProjectViewModal,
        solidBackground: false,
        closeLeft: true,
    };
    SHARED_MODALS['competition-sent'] = {
        closable: false,
        component: CompetitionBravoModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['competition-sent-error'] = {
        closable: false,
        component: CompetitionBravoErrorModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['shop-sent'] = {
        closable: false,
        component: SendBrndItemModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['image-sent'] = {
        closable: true,
        component: SendImagesModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['sent-to-competition'] = {
        closable: true,
        component: SendProjectToCompetition,
        solidBackground: true,
        closeLeft: true,
        importantBlack: true,
        mobileVersion: true,
        hideCloseOnMobile: true
    };
    SHARED_MODALS['geolocation-tags'] = {
        closable: false,
        component: SelectGeoLocationTagsModal,
        solidBackground: true,
        closeLeft: true,
        hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-products'] = {
        closable: true,
        component: ProductsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-reproductions'] = {
        closable: true,
        component: ReproductionSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-collections'] = {
        closable: true,
        component: CollectionsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-calendars'] = {
        closable: true,
        component: CalendarsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['not-saved-data'] = {
        closable: false,
        component: NotSavedDataModal,
        closeLeft: true,
    };
    SHARED_MODALS['lock-data'] = {
        component: LockDataModal,
        solidBackground: true,
        customFillBackgroundColor: 'rgba(21, 21, 20, 0.64)'
    };
    SHARED_MODALS['competition-legals'] = {
        closable: true,
        component: CompetitionLegalsModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['code-viewer'] = {
        closable: true,
        component: CodeViewerModal,
        customHoverCloserColor: '#ffffff',
    };
    SHARED_MODALS['sorting-modal'] = {
        closable: true,
        component: SortingModal,
        solidBackground: true,
        hideCloseOnMobile: true,
        customFillBackgroundColor: 'rgba(255,255,255,0.6)'
    };
    SHARED_MODALS['project-publish'] = {
        component: ProjectPublishModal,
        shadowClosableBackground: true,
        mobileFlexEnd: true,
    };
    SHARED_MODALS['competition-custom-legals'] = {
        closable: true,
        component: CustomLegalsModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['application-form'] = {
        closable: true,
        component: ApplicationFormTemplate,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['custom-info-modal'] = {
        closable: true,
        component: CustomInfoModal,
        solidBackground: false,
    };
    SHARED_MODALS['send-project'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['send-project-longread'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectLongreadModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['tag-description-edit'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: TagDescriptionModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['send-project-employ'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectForEmploy,
        solidBackground: true,
        headerVisibleMobile: true,
        mobileFlexStart: true,
        closeLeft: true,
    };
    SHARED_MODALS['group'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: GroupModal,
        solidBackground: true,
        headerVisibleMobile: true,
        mobileFlexStart: true,
        closeLeft: true,
    };
    SHARED_MODALS['artz-legals'] = {
        mobileFlexStart: true,
        shadowClosableBackground: true,
        component: ArtzLegalsModal,
    };
    SHARED_MODALS['artz-legals-success'] = {
        shadowClosableBackground: true,
        component: SuccessModal,
    };
    SHARED_MODALS['access'] = {
        shadowClosableBackground: true,
        component: AccessModal,
    };
    SHARED_MODALS['confirmation'] = {
        shadowClosableBackground: true,
        component: ConfirmationModal,
    };
    SHARED_MODALS['artz-legals-error'] = {
        shadowClosableBackground: true,
        component: ErrorModal,
    };
    SHARED_MODALS['artz-legals-load'] = {
        shadowClosableBackground: true,
        component: LoadingModal,
    };
    SHARED_MODALS['share'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ShareModal,
    };

    SHARED_MODALS['folder-projects-edit'] = {
        // shadowClosableBackground: true,
        solidBackground: true,
        mobileFlexEnd: true,
        hideCloseOnMobile: true,
        component: FoldersProjectsEdit,
    };

    SHARED_MODALS['tags'] = {
        closable: true,
        component: SelectTagsModal,
        headerVisibleMobile: true,
        hideCloseOnMobile: true,
    };

    SHARED_MODALS['feedback'] = {
        closable: true,
        component: FeedbackForm,
    };

    SHARED_MODALS['report'] = {
        closable: true,
        component: ReportForm,
        mobileFlexStart: true,
        tabletFlexStart: true,
        hideCloseOnMobile: true,
        mobileSolidBackground: true,
        headerVisibleMobile: true,
    };

    SHARED_MODALS['select-chapters'] = {
        closable: true,
        component: SelectChapters,
        mobileVersion: true
    };

    SHARED_MODALS['select-short-list'] = {
        closable: true,
        component: SelectShortList,
        mobileVersion: true
    };

    SHARED_MODALS['legals'] = {
        closable: true,
        component: LegalsModal,
    };
    SHARED_MODALS['terms-of-use'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: TermsOfUseModal
    };
    SHARED_MODALS['schedule'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: ScheduleModal
    };
    SHARED_MODALS['check-homework'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: CheckHomeworkModal
    };
    SHARED_MODALS['previewer'] = {
        closable: true,
        shadowClosableBackground: true,
        component: PreviewerModal,
        isPreviewer: true
    };
    SHARED_MODALS['paymentError'] = {
        closable: true,
        component: PaymentError,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['paymentErrorModal'] = {
        closable: true,
        component: PaymentErrorModal,
    }

    SHARED_MODALS['paymentSuccess'] = {
        closable: true,
        component: PaymentSuccess,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }

    SHARED_MODALS['paymentManager'] = {
        closable: true,
        component: PaymentManager,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['bookPaymentSuccess'] = {
        closable: true,
        component: BookPaymentSuccess,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['topUpBalance'] = {
        closable: true,
        component: TopUpBalance,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['ageRestricted'] = {
        closable: false,
        component: AgeRestrictionModal,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['paymentUnavailable'] = {
        closable: false,
        component: PaymentUnavailableModal,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['sendConfirmation'] = {
        closable: false,
        component: SendConfirmation,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['competitionProjectSent'] = {
        closable: true,
        component: CompetitionProjectSent,
        // customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['createTag'] = {
        closable: true,
        component: CreateTagComponent
    }
    SHARED_MODALS['teamSubscribe'] = {
        closable: false,
        component: TeamSubscribe,
        customFillBackgroundColor: 'transparent',
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    }
    SHARED_MODALS['confirmCourseCompletionModal'] = {
        closable: true,
        component: ConfirmCourseCompletionModal,
        closeLeft: true,
        customFillBackgroundColor: 'rgba(0,0,0,0.20)'
    };
     SHARED_MODALS['formula'] = {
        closable: true,
        component: FormulaEditor,
        headerVisibleMobile: true,
        hideCloseOnMobile: true,
    };
};
import { SHARED_APPLICATIONS, SHARED_MODALS } from '../core';
import TeamApp from './apps/_team/app';
import ConsoleApp from './apps/_console/app';
import { SelectTagsModal, SelectGeoLocationTagsModal } from './modals';
import { ProjectViewModal } from './modals/projectViewModal';
import { CompetitionBravoModal } from './modals/competitionBravoModal';
import { CompetitionBravoErrorModal } from './modals/competitionBravoErrorModal';
import { CompetitionLegalsModal } from './modals/competitionLegalsModal/competitionLegalsModal';
import { SendProjectModal } from './modals/sendProjects/SendProjectModal';
import { FeedbackForm } from './components/feedbackForm';
import { ReportForm } from './components/reportForm';
import { NotSavedDataModal } from './modals/notSavedData/notSavedData';
import { SelectChapters } from './modals/selectChapters/SelectChapters';
import { LegalsModal } from "./modals/legalsModal";
import { SelectShortList } from './modals/selectShortList/SelectShortList';
import {SendProjectForEmploy} from "./modals/sendProjects/SendProjectForEmploy";
import {ShareModal} from "./modals/ShareModal/ShareModal";
import TermsOfUseModal from './modals/TermsOfUseModal';
import NotificationList from "./components/NotificationsController/NotificationList";
import {     
    ArtzLegalsModal,
    ErrorModal,
    SuccessModal,
    LoadingModal } from './modals/artzLegalsModal';
import GroupModal from './modals/groups';
import {SendBrndItemModal} from "./modals/sendProjects/SendBrndItemModal";
import {SendImagesModal} from "./modals/sendProjects/SendImagesModal";
import {ScheduleModal} from "./modals/scheduleModal/scheduleModal";
import {CheckHomeworkModal} from './modals/checkHomeworkModal/checkHomeworkModal';
import {PreviewerModal} from "./modals/previewerModal/previewerModal";
import {SendProjectLongreadModal} from "./modals/sendProjects/SendProjectLongreadModal";
import PaymentError from "./features/QueuePaymenrt/payment/PaymentError";
import PaymentSuccess from "./features/QueuePaymenrt/payment/PaymentSuccess";
import PaymentManager from "./features/QueuePaymenrt/payment/PaymentManager";
import { SendProjectToCompetition } from './modals/sendProjects/SendProjectToCompetition';
import {BookPaymentSuccess} from "./features/QueuePaymenrt/components/BookPaymentSuccess/BookPaymentSuccess";
import TopUpBalance from './features/QueuePaymenrt/payment/TopUpBalance';
import { AgeRestrictionModal } from "./modals/AgeRestrictionModal/AgeRestrictionModal";
import { CustomLegalsModal } from './modals/customLegalsModal/customLegalsModal';
import { ProjectPublishModal } from './modals/projectPublishModal/ProjectPublishModal';
import { PaymentErrorModal } from './modals/PaymentErrorModal';
import { SortingModal } from './modals/SortingModal/SortingModal';
import {TeamSubscribe} from "./modals/TeamSubscribe/TeamSubscribe";
import { CustomInfoModal } from './modals/CustomInfoModal/CustomInfoModal';
import {SelectContextModalNew} from "./modals/selectContextModalNew";
import { CreateTagComponent } from './modals/selectTagsModal/components/CreateTagComponent/CreateTagComponent';
import {CodeViewerModal} from "./modals/CodeViewerModal/CodeViewerModal";
import { LockDataModal } from './modals/lockDataModal/LockDataModal';
import { FoldersProjectsEdit } from './modals/FolderModal';
import ProductsSelectModal from './modals/CardSelectModal/ProductsSelectModal';
import ReproductionSelectModal from './modals/CardSelectModal/ReproductionSelectModal';
import { ConfirmDeleteCoverModal } from './modals/confirmCoverDeleteModal';
import { SubscribeUserModal } from './modals/subscribeUser/SubscribeUserModal';
import { FormDropdownEdit } from './modals/formDropdownEdit/FormDropdownEdit';
import {ApplicationFormTemplate} from "./modals/ApplicationFormTemplate/applicationFormTemplate";
import { TagDescriptionModal } from './modals/TagDescriptionModal/TagDescriptionModal';
import { RepostModal } from './modals/repostModal/RepostModal';
import { TemplateModal } from './modals/TemplateModal/TemplateModal';
import { ConfirmCourseCompletionModal } from './modals/ConfirmCourseCompletion';
import CollectionsSelectModal from './modals/CardSelectModal/CollectionsSelectModal';
import CalendarsSelectModal from './modals/CardSelectModal/CalendarsSelectModal';
import { FormulaEditor } from './pages/projectEdit/components/PresentatitonBlock/FormulaEditor';
import { AccessModal } from './modals/AccessModal/AccessModal';
import { ConfirmationModal } from './modals/ConfirmationModal/ConfirmationModal';

import PaymentUnavailableModal from './modals/PaymentUnavailableModal/PaymentUnavailableModal';
import SendConfirmation from './modals/SendConfirmation/SendConfirmation';
import CompetitionProjectSent from './modals/CompetitionProjectSent/CompetitionProjectSent';

export const setupApp = (): void => {
    SHARED_APPLICATIONS['team'] = TeamApp;
    SHARED_APPLICATIONS['console'] = ConsoleApp;

    SHARED_MODALS['confirmDeleteCoverModal'] = {
        closable: true,
        component: ConfirmDeleteCoverModal,
        closeLeft: true,
        customFillBackgroundColor: 'rgba(0,0,0,0.20)'
        
    };

    SHARED_MODALS['context-new'] = {
        closable: true,
        component: SelectContextModalNew,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['notifications'] = {
        closable: false,
        component: NotificationList,
        solidBackground: true,
        closeLeft: false,
        headerVisibleMobile: true,
        containerId: "notification-dropdown",
    };
    SHARED_MODALS['subscribe-user'] = {
        closable: false,
        component: SubscribeUserModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['template-modal'] = {
        closable: false,
        component: TemplateModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['repost-into-channel'] = {
        closable: false,
        component: RepostModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }

    SHARED_MODALS['form-dropdown-edit'] = {
        closable: false,
        component: FormDropdownEdit,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['template-modal'] = {
        closable: false,
        component: TemplateModal,
        customFillBackgroundColor: 'rgba(0,0,0,0.65)'
    }
    SHARED_MODALS['project'] = {
        closable: true,
        component: ProjectViewModal,
        solidBackground: false,
        closeLeft: true,
    };
    SHARED_MODALS['competition-sent'] = {
        closable: false,
        component: CompetitionBravoModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['competition-sent-error'] = {
        closable: false,
        component: CompetitionBravoErrorModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['shop-sent'] = {
        closable: false,
        component: SendBrndItemModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['image-sent'] = {
        closable: true,
        component: SendImagesModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['sent-to-competition'] = {
        closable: true,
        component: SendProjectToCompetition,
        solidBackground: true,
        closeLeft: true,
        importantBlack: true,
        mobileVersion: true,
        hideCloseOnMobile: true
    };
    SHARED_MODALS['geolocation-tags'] = {
        closable: false,
        component: SelectGeoLocationTagsModal,
        solidBackground: true,
        closeLeft: true,
        hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-products'] = {
        closable: true,
        component: ProductsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-reproductions'] = {
        closable: true,
        component: ReproductionSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-collections'] = {
        closable: true,
        component: CollectionsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['project-calendars'] = {
        closable: true,
        component: CalendarsSelectModal,
        solidBackground: true,
        // hideCloseOnMobile: true,
    };
    SHARED_MODALS['not-saved-data'] = {
        closable: false,
        component: NotSavedDataModal,
        closeLeft: true,
    };
    SHARED_MODALS['lock-data'] = {
        component: LockDataModal,
        solidBackground: true,
        customFillBackgroundColor: 'rgba(21, 21, 20, 0.64)'
    };
    SHARED_MODALS['competition-legals'] = {
        closable: true,
        component: CompetitionLegalsModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['code-viewer'] = {
        closable: true,
        component: CodeViewerModal,
        customHoverCloserColor: '#ffffff',
    };
    SHARED_MODALS['sorting-modal'] = {
        closable: true,
        component: SortingModal,
        solidBackground: true,
        hideCloseOnMobile: true,
        customFillBackgroundColor: 'rgba(255,255,255,0.6)'
    };
    SHARED_MODALS['project-publish'] = {
        component: ProjectPublishModal,
        shadowClosableBackground: true,
        mobileFlexEnd: true,
    };
    SHARED_MODALS['competition-custom-legals'] = {
        closable: true,
        component: CustomLegalsModal,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['application-form'] = {
        closable: true,
        component: ApplicationFormTemplate,
        solidBackground: true,
        closeLeft: true,
    };
    SHARED_MODALS['custom-info-modal'] = {
        closable: true,
        component: CustomInfoModal,
        solidBackground: false,
    };
    SHARED_MODALS['send-project'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['send-project-longread'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectLongreadModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['tag-description-edit'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: TagDescriptionModal,
        solidBackground: true,
        headerVisibleMobile: true,
        closeLeft: true,
    };
    SHARED_MODALS['send-project-employ'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: SendProjectForEmploy,
        solidBackground: true,
        headerVisibleMobile: true,
        mobileFlexStart: true,
        closeLeft: true,
    };
    SHARED_MODALS['group'] = {
        closable: true,
        hideCloseOnMobile: true,
        component: GroupModal,
        solidBackground: true,
        headerVisibleMobile: true,
        mobileFlexStart: true,
        closeLeft: true,
    };
    SHARED_MODALS['artz-legals'] = {
        mobileFlexStart: true,
        shadowClosableBackground: true,
        component: ArtzLegalsModal,
    };
    SHARED_MODALS['artz-legals-success'] = {
        shadowClosableBackground: true,
        component: SuccessModal,
    };
    SHARED_MODALS['access'] = {
        shadowClosableBackground: true,
        component: AccessModal,
    };
    SHARED_MODALS['confirmation'] = {
        shadowClosableBackground: true,
        component: ConfirmationModal,
    };
    SHARED_MODALS['artz-legals-error'] = {
        shadowClosableBackground: true,
        component: ErrorModal,
    };
    SHARED_MODALS['artz-legals-load'] = {
        shadowClosableBackground: true,
        component: LoadingModal,
    };
    SHARED_MODALS['share'] = {
        shadowClosableBackground: true,
        mobileFlexEnd: true,
        component: ShareModal,
    };

    SHARED_MODALS['folder-projects-edit'] = {
        // shadowClosableBackground: true,
        solidBackground: true,
        mobileFlexEnd: true,
        hideCloseOnMobile: true,
        component: FoldersProjectsEdit,
    };

    SHARED_MODALS['tags'] = {
        closable: true,
        component: SelectTagsModal,
        headerVisibleMobile: true,
        hideCloseOnMobile: true,
    };

    SHARED_MODALS['feedback'] = {
        closable: true,
        component: FeedbackForm,
    };

    SHARED_MODALS['report'] = {
        closable: true,
        component: ReportForm,
        mobileFlexStart: true,
        tabletFlexStart: true,
        hideCloseOnMobile: true,
        mobileSolidBackground: true,
        headerVisibleMobile: true,
    };

    SHARED_MODALS['select-chapters'] = {
        closable: true,
        component: SelectChapters,
        mobileVersion: true
    };

    SHARED_MODALS['select-short-list'] = {
        closable: true,
        component: SelectShortList,
        mobileVersion: true
    };

    SHARED_MODALS['legals'] = {
        closable: true,
        component: LegalsModal,
    };
    SHARED_MODALS['terms-of-use'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: TermsOfUseModal
    };
    SHARED_MODALS['schedule'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: ScheduleModal
    };
    SHARED_MODALS['check-homework'] = {
        closable: true,
        solidBackground: false,
        fullscreen: true,
        component: CheckHomeworkModal
    };
    SHARED_MODALS['previewer'] = {
        closable: true,
        shadowClosableBackground: true,
        component: PreviewerModal,
        isPreviewer: true
    };
    SHARED_MODALS['paymentError'] = {
        closable: true,
        component: PaymentError,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['paymentErrorModal'] = {
        closable: true,
        component: PaymentErrorModal,
    }

    SHARED_MODALS['paymentSuccess'] = {
        closable: true,
        component: PaymentSuccess,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }

    SHARED_MODALS['paymentManager'] = {
        closable: true,
        component: PaymentManager,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['bookPaymentSuccess'] = {
        closable: true,
        component: BookPaymentSuccess,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['topUpBalance'] = {
        closable: true,
        component: TopUpBalance,
        customFillBackgroundColor: 'rgb(232, 232, 232)'
    }
    SHARED_MODALS['ageRestricted'] = {
        closable: false,
        component: AgeRestrictionModal,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['paymentUnavailable'] = {
        closable: false,
        component: PaymentUnavailableModal,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['sendConfirmation'] = {
        closable: false,
        component: SendConfirmation,
        customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['competitionProjectSent'] = {
        closable: true,
        component: CompetitionProjectSent,
        // customFillBackgroundColor: 'transparent'
    }
    SHARED_MODALS['createTag'] = {
        closable: true,
        component: CreateTagComponent
    }
    SHARED_MODALS['teamSubscribe'] = {
        closable: false,
        component: TeamSubscribe,
        customFillBackgroundColor: 'transparent',
        shadowClosableBackground: true,
        shadowClosableBackgroundMobile: true,
    }
    SHARED_MODALS['confirmCourseCompletionModal'] = {
        closable: true,
        component: ConfirmCourseCompletionModal,
        closeLeft: true,
        customFillBackgroundColor: 'rgba(0,0,0,0.20)'
    };
     SHARED_MODALS['formula'] = {
        closable: true,
        component: FormulaEditor,
        headerVisibleMobile: true,
        hideCloseOnMobile: true,
    };
};
